/**
 * Mapeia o status da API para exibição em português
 */
export function getStatusLabel(statusName: string): string {
  const statusMap: Record<string, string> = {
    success: "Sucesso",
    error: "Erro",
    timeout: "Timeout",
    rate_limited: "Rate Limited",
    processing: "Processando",
    cancelled: "Cancelada",
  };

  return statusMap[statusName] || statusName;
}

/**
 * Retorna a variante do Badge baseada no status
 */
export function getStatusVariant(
  statusName: string
): "default" | "secondary" | "destructive" | "outline" {
  switch (statusName) {
    case "success":
      return "secondary";
    case "error":
      return "destructive";
    case "processing":
      return "outline";
    default:
      return "default";
  }
}

